import {createAction, createAsyncAction} from "typesafe-actions";
import {IFileData} from "./types";
import {AtLeastOne, IdObjectsWithId} from "../../../utils";

export const fetchFileDataByIdAsyncActions = createAsyncAction(
    'FETCH_FILE_DATA_BY_ID_REQUEST',
    'FETCH_FILE_DATA_BY_ID_SUCCESS',
    'FETCH_FILE_DATA_BY_ID_FAILURE'
)<{ id: string }, { fileData: IFileData }, { error: Error }>();

export interface ILoadDataForFilesActionPayload {
    fileIds: string[]
}

export interface ILoadDataForFilesActionSuccessPayload {
    ids: string[]
    filesData: IdObjectsWithId<IFileData>
}

export const loadDataForFilesAsyncAction = createAsyncAction(
    'LOAD_FILES_DATA_REQUEST',
    'LOAD_FILES_DATA_SUCCESS',
    'LOAD_FILES_DATA_FAILURE'
)<ILoadDataForFilesActionPayload, ILoadDataForFilesActionSuccessPayload, { error: Error }>();



export const fetchFileDataAsyncActions = createAsyncAction(
    'FETCH_FILE_DATA_REQUEST',
    'FETCH_FILE_DATA_SUCCESS',
    'FETCH_FILE_DATA_FAILURE'
)<{}, { fileDataList: IdObjectsWithId<IFileData> }, { error: Error }>();

export const saveFileDataAsyncActions = createAsyncAction(
    'SAVE_FILE_DATA_REQUEST',
    'SAVE_FILE_DATA_SUCCESS',
    'SAVE_FILE_DATA_FAILURE'
)<{ fileData: AtLeastOne<IFileData, { id: { id: string } }> }, { fileData: IFileData }, { error: Error }>();

export const deleteFileDataAsyncActions = createAsyncAction(
    'DELETE_FILE_DATA_REQUEST',
    'DELETE_FILE_DATA_SUCCESS',
    'DELETE_FILE_DATA_FAILURE'
)<{ id: string }, { id: string }, { error: Error }>();


export interface IModifyingActiveFileDataActionPayload {
    fileData: Partial<IFileData>;
}

export const modifyingActiveFileDataAction = createAction('MODIFYING_ACTIVE_FILE_DATA', action => {
    return (params: IModifyingActiveFileDataActionPayload) => action(params);
});
